import { render } from "./MainSalesReferralGuide.vue?vue&type=template&id=d13ff90a&scoped=true"
import script from "./MainSalesReferralGuide.vue?vue&type=script&lang=js"
export * from "./MainSalesReferralGuide.vue?vue&type=script&lang=js"

import "./MainSalesReferralGuide.vue?vue&type=style&index=0&id=d13ff90a&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\front-api\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d13ff90a"]])

export default __exports__